/**
 * Single list of repository media the public site ships. The Vite media plugin
 * serves exactly these files in development and emits only these in a build,
 * so the full 3D kit / photo library is never published by accident.
 * Pure data: imported by vite.config.ts and by the app.
 */
import type { KitAssetId, Lod } from '../three/catalog';

/** Kit assets the site ships: globe traffic (vehicles, LOD2) and the process studio (product shots). */
export const SITE_KIT: Readonly<Partial<Record<KitAssetId, readonly Lod[]>>> = {
  '3D_03_WOODEN_EXPORT_CRATE': ['master', 'lod1', 'lod2'],
  '3D_06_WRAPPED_PALLET': ['master', 'lod1', 'lod2'],
  '3D_08_INDUSTRIAL_COMPONENT_GENERIC': ['master', 'lod1', 'lod2'],
  '3D_09_CONTAINER_TRUCK': ['lod1', 'lod2'],
  '3D_11_CONTAINER_VESSEL_SIMPLIFIED': ['lod1', 'lod2'],
  '3D_12_CARGO_AIRCRAFT_SIMPLIFIED': ['lod1', 'lod2'],
  '3D_18_MICROMETER': ['master', 'lod1', 'lod2'],
  '3D_20_TECHNICAL_EVIDENCE_FOLDER': ['master', 'lod1', 'lod2'],
  '3D_23_APPROVED_REFERENCE_SAMPLE': ['master', 'lod1', 'lod2'],
  '3D_25_FACTORY_NODE': ['master', 'lod1', 'lod2'],
  '3D_28_CUSTOMS_ARRIVAL_NODE': ['master', 'lod1', 'lod2'],
  '3D_31_CONTROL_MONITOR': ['master', 'lod1', 'lod2'],
};

/** Approved photographic masters used editorially (China control, industries). */
export const SITE_PHOTOS = ['B02_06', 'B05_18', 'B05_19', 'B05_20', 'B05_17'] as const;
export type SitePhotoId = (typeof SITE_PHOTOS)[number];
export const PHOTO_WIDTHS = [640, 960, 1376] as const;
export const PHOTO_FORMATS = ['avif', 'webp'] as const;
